import { AppEndpoints } from '../app.endpoints';
import { HttpService } from '../../globals/providers/http.service';
import { Observable } from 'rxjs/Observable';
import { IUserStatusReq, ITwoFactorAutheticationRequest } from '../classes/http-requests';
import { IUserData, UserData } from '../../globals/classes/userData';
import { IImpersonationUserStatusResponse } from '../classes/http-responses';
import { timer } from 'rxjs';
import { map } from 'rxjs/operators';

export class ImpersonationService {
	public static checkUserStatus(
		username: string,
		mock = false
	): Observable<IImpersonationUserStatusResponse> {
		const request: IUserStatusReq = {
			username: username,
		};

		if (mock == true) {
			return ImpersonationService.checkUserStatusMock(request);
		} else {
			return ImpersonationService.checkUserStatusActual(request, username);
		}
	}

	public static login(userId: string, otp: string): Observable<void> {
		const request: ITwoFactorAutheticationRequest = {
			userID: userId,
			password: otp,
		};

		return HttpService.post(AppEndpoints.impersonationLogin, request);
	}

	private static checkUserStatusActual(
		request: IUserStatusReq,
		username: string
	): Observable<IImpersonationUserStatusResponse> {
		return HttpService.post<IImpersonationUserStatusResponse>(
			AppEndpoints.impersonationUserStatus,
			request
		).pipe(
			map((resp) => {
				const userData: IUserData = {
					userId: username,
					userType: !!resp.userType ? resp.userType.trim() : null,
					hasSMSOtp: ImpersonationService.extractHasSMSOtpValue(resp),
					maskedPhoneNumber: ImpersonationService.extractMaskedPhoneNumberValue(resp),
				};
				UserData.update(userData);
				return resp;
			})
		);
	}

	private static extractMaskedPhoneNumberValue(resp: IImpersonationUserStatusResponse): string {
		return !!resp.additionalAuthenticationInfo &&
			!!resp.additionalAuthenticationInfo.verificationCodeInfo
			? resp.additionalAuthenticationInfo.verificationCodeInfo.target
			: null;
	}

	private static extractHasSMSOtpValue(resp: IImpersonationUserStatusResponse): boolean {
		return !!resp.additionalAuthenticationInfo &&
			!!resp.additionalAuthenticationInfo.verificationCodeInfo
			? resp.additionalAuthenticationInfo.verificationCodeInfo.hasOtp
			: false;
	}

	private static checkUserStatusMock(
		request: IUserStatusReq
	): Observable<IImpersonationUserStatusResponse> {
		let dummyResponse: IImpersonationUserStatusResponse = {
			userStatus: 'ACTIVE',
			userType: 'PERSON',
			ux: null,
			additionalAuthenticationInfo: {
				actualUserId: '2162555',
				reasonInfo: {
					reasonCode: '202',
					reasonDescription: 'Impersonation',
				},
				verificationCodeInfo: {
					codeLifetimeInSeconds: 300.0,
					timestamp: new Date('2021-02-10T11:26:45.0622569+02:00'),
					target: '*******407',
					hasOtp: true,
				},
			},
		};

		return timer(2500).pipe(map(() => dummyResponse));
	}
}
